import { useAxios } from '@/context/axiosContext'
import { useAppSelector } from '@/redux/hooks'
import React, { RefObject, useState } from 'react'
import { CustomerComment } from './customerComment'
import { InsertComment } from './insertComment'
import { useDialog } from '@/context/dialogContext'
import { useLocation } from 'react-router-dom'
import {
  buttonName,
  CommentListItem,
  confirmMessages,
  fieldMessages,
  successMessages,
} from '@/pages/board/boardItem'
import { useResponsive } from '@/hooks/useResponsive'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
type ModalAction = 'insert' | 'delete' | 'update'

interface Data {
  //cmpnyCd: string
  nttSn: number
  commentSn: number
  option: string
}
interface CommentsProps {
  commentListCnt: number
  nttSn: number
  commentList: CommentListItem[]
  nickName?: string
  cstId?: string
  withDraw?: string
  onDataSaved?: () => void
  getCommentList?: () => void
  scrollToComment?: () => void
  commentRef: RefObject<HTMLDivElement>
}

export const Comments: React.FC<CommentsProps> = ({
  commentListCnt,
  nttSn,
  commentList,
  nickName,
  cstId,
  withDraw,
  onDataSaved,
  getCommentList,
  scrollToComment,
  commentRef,
}) => {
  const axios = useAxios()
  const location = useLocation()
  const { showAlert, showConfirm } = useDialog()
  //const [searchParams] = useSearchParams()
  //const nttSn = Number(searchParams.get('nttSn')) // 게시판 번호
  const { isAuthenticated, user } = useAppSelector((state) => state.auth)
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const [formData, setFormData] = useState({
    cmpnyCd: '001',
    nttSn: nttSn,
    commentCn: '',
    cstId: user?.cstId, //고객번호 (우선하드코딩) 로그인데이터를 가져오도록 수정필요
    userId: user?.userId, //userId
  })

  const handleChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value } = e.target as HTMLInputElement | HTMLTextAreaElement
    setFormData((prev) => ({ ...prev, [name]: value }))
  }

  // 공통 처리 함수
  const handleCommentAction = (action: ModalAction, commentSn?: any) => {
    // 선택된 item이 있다면 해당 item의 COMMENT_SN을 저장

    if (action === 'insert' && !formData.commentCn) {
      showAlert({
        type: 'warning',
        title: fieldMessages.nttCn,
        btnName: buttonName.confirm,
      })
      return
    }

    if (action === 'insert') {
      showConfirm({
        title: confirmMessages.insert,
        confirmBtnName: buttonName.confirm,
        cancelBtnName: buttonName.cancel,
        onConfirm() {
          insertComment()
        },
      })
    }

    if (action === 'delete') {
      showConfirm({
        title: confirmMessages.delete,
        confirmBtnName: buttonName.confirm,
        cancelBtnName: buttonName.cancel,
        onConfirm() {
          deleteComment(commentSn)
        },
      })
    }
  }

  const insertComment = async () => {
    try {
      const insertFormData = {
        ...formData,
        option: 'ADD',
      }

      const response = await axios.post(
        `/feedback/comment/insert`,
        insertFormData,
      )

      setFormData((prevData) => ({
        ...prevData, // 기존 값 유지
        commentCn: '',
      }))
      getCommentList?.()
    } catch (err: any) {
      console.error('Error insertComment:', err)
    }
  }

  const deleteComment = async (commentSn: number) => {
    const data: Data = {
      nttSn: nttSn,
      commentSn: commentSn,
      option: 'DEL',
    }

    try {
      await axios.post(`/feedback/comment/delete`, data)
      showAlert({
        type: 'success',
        title: successMessages.delete,
        onClose() {
          setTimeout(() => {
            getCommentList?.()
          }, 100)
        },
      })
    } catch (err: any) {
      console.error('Error deleteComment :', err)
    }
  }

  return (
    <>
      {!isMobile ? (
        <>
          {commentListCnt > 0 && (
            <div style={{ marginBottom: '10px', color: '#979797' }}>
              댓글 [{commentListCnt}]
            </div>
          )}
        </>
      ) : (
        <>
          {commentListCnt > 0 && (
            <div className="comments-header">
              댓글
              <span className="comments-count">{commentListCnt}</span>
            </div>
          )}
        </>
      )}
      <CustomerComment
        commentList={commentList}
        handleCommentAction={handleCommentAction}
        isAuthenticated={isAuthenticated}
        userCstId={user?.cstId}
        isMobile={isMobile}
      />
      <InsertComment
        formData={formData}
        nickName={nickName}
        handleCommentAction={handleCommentAction}
        isAuthenticated={isAuthenticated}
        handleChange={handleChange}
        isMobile={isMobile}
      />
    </>
  )
}
